<div class="all">
    <div class="login">
        <img src="assets/logo_{{sezione}}.png" width="auto" height="40"/>
        <mat-card flex="flex" flex-gt-sm="50" flex-gt-md="33">
            <mat-toolbar>{{area}}</mat-toolbar>
            <div class="errore" *ngIf="errore"> 
                {{testoErrore}}
            </div>
            <form *ngIf="(sezioneLogin=='login')">
                <mat-form-field mat-block class="mat-block">
                    <input [(ngModel)]="email" name="email" matInput placeholder="Username" required="Richiesto">
                </mat-form-field><br>
                <mat-form-field mat-block class="mat-block">
                    <input [(ngModel)]="password" type="password" name="password" matInput placeholder="Password" required="Richiesto">
                </mat-form-field><br>
                <a (click)="vaiRecupera()">Recupera password/Forgot password?</a>
                <button mat-raised-button color="primary" (click)="onSubmit()">Login</button>
            </form>
            <form *ngIf="(sezioneLogin=='recupera')">
                <mat-form-field mat-block class="mat-block">
                    <input [(ngModel)]="email" name="email" matInput placeholder="Username" required="Richiesto">
                </mat-form-field><br>
                <button mat-raised-button color="primary" (click)="inviaDatiRecupera()">INVIA</button>
            </form>
            <form *ngIf="(sezioneLogin=='reimposta')">
                <mat-form-field mat-block class="mat-block">
                    <input [(ngModel)]="email" name="email" matInput placeholder="Username" required="Richiesto">
                </mat-form-field><br>
                <mat-form-field mat-block class="mat-block">
                    <input [(ngModel)]="code" name="email" matInput placeholder="Codice/Code" required="Richiesto">
                </mat-form-field><br>
                <button mat-raised-button color="primary" (click)="inviaCodiceReimposta()">INVIA</button>
            </form>
            <form *ngIf="(sezioneLogin=='nuovaPasswordFromToken')">
                <mat-form-field mat-block class="mat-block">
                    <input [(ngModel)]="password" type="password" name="password" matInput placeholder="New Password" required="Richiesto">
                </mat-form-field><br>
                 <mat-form-field mat-block class="mat-block">
                    <input [(ngModel)]="password2" type="password" name="password2" matInput placeholder="Confirm New Password" required="Richiesto">
                </mat-form-field><br>
                <button mat-raised-button color="primary" (click)="inviaNuovaPassword()">INVIA</button>
            </form>
             <form *ngIf="(sezioneLogin=='nuovaPasswordFromLogin')">
                <mat-form-field mat-block class="mat-block">
                    <input [(ngModel)]="password" type="password" name="password" matInput placeholder="New Password" required="Richiesto">
                </mat-form-field><br>
                 <mat-form-field mat-block class="mat-block">
                    <input [(ngModel)]="password2" type="password" name="password2" matInput placeholder="Confirm New Password" required="Richiesto">
                </mat-form-field><br>
                <button mat-raised-button color="primary" (click)="inviaNuovaPasswordAuth()">INVIA</button>
            </form>
        </mat-card> <br *ngIf="(sezioneLogin!='info')"> 
        <mat-card flex="flex" flex-gt-sm="80" flex-gt-md="50" class="scritta" [innerHTML]=infoIta>
        
        </mat-card><br>
        <mat-card flex="flex" flex-gt-sm="80" flex-gt-md="50" class="scritta"  [innerHTML]=infoEng>
        </mat-card>
        <br/>
        <button *ngIf="puls" mat-raised-button color="primary" (click)="goLogin()">LOGIN</button>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/tws-login/tws-login.component.html